import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NormalizadorService } from '../../services/normalizador.service';
import { DraftService } from '../../services/draft.service';
import { GeneralService } from '../../services/general.service';
import { ApiAmenaService } from '../../services/api-amena.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-cobertura-migration',
    templateUrl: './cobertura-migration.component.html',
    styleUrls: ['./cobertura-migration.component.css'],
    standalone: false
})
export class CoberturaMigrationComponent implements OnInit {
    // Controla si se muestra el formulario
    muestraCobertura: boolean;
    muestraErrorPeticion = false;
    muestraBotonesCobertura = false;
    muestraBotonNinguna = false;
    isLoading = false;
    textDefault = 'Comprobar cobertura';
    // Almacena los datos de la consulta del normalizador
    datosNormalizacion: any = null;
    // Declaramos el formGroup del componente Cobertura
    // Importamos el formGroup del amena componente
    @Input() firstFormGroup: FormGroup;
    formularioNormalizacion: FormGroup;
    // Datos del modelo
    localidades: any = null;
    direccionesSugeridas: any = null;
    plantas: any = null;
    bisOption: any = null;
    bloqueOption: any = null;
    bloqueLabel: any = null;
    portalOption: any = null;
    escaleraOption: any = null;
    tipoPuertaOption: any = null;
    puertaOption: any = null;
    consulta: any = null;
    msgErrorPeticion: any;
    orderDraftId = null;
    htmlErrorCobertura: string = '<div class="col-lg-12"><h5 class="mb-0">Lo sentimos, no tienes cobertura de fijo</h5> a través de la red de Amena.</div>';
    public flagUAT: boolean = false;
    public enviroment = environment;

    public subcribeDatosNormalizacion: any;
    public subcribeLocalidades: any;
    public dataCustomer: any;
    public migrationData: any;

    constructor(
        private formBuilder: FormBuilder,
        private normalizadorService: NormalizadorService,
        private draftService: DraftService,
        private generalService: GeneralService,
        private amenaService: ApiAmenaService
    ) { }

    ngOnInit(): void {
        // Definimos el formGroup y los formControl que llevara el formulario
        this.firstFormGroup = this.formBuilder.group({
            localidadCobertura: ['', Validators.required],
            direccionesCobertura: ['', Validators.required],
            tipoViaCobertura: ['', ''],
            nombreViaCobertura: ['', ''],
            numeroCobertura: ['', ''],
            provinciaCobertura: ['', ''],
            codigoPostalCobertura: ['', ''],
            plantaCobertura: ['', Validators.required],
            bisCobertura: [null, ''],
            bloqueCobertura: [null, ''],
            portalCobertura: [null, ''],
            escaleraCobertura: [null, ''],
            tipoPuertaCobertura: [null, ''],
            puertaCobertura: [null, ''],
            resultadoConsultaCobertura: ['', ''],
            portabilidadFijo: ['', ''],
            serviceProviderFijo: ['', ''],
            tipoAltaFijo: ['', ''],
            numeroApartamento: [''],
            cp_vat: [''],
            cp_price: [''],
            cp_price_without_vat: ['']
        });
        // Actualizamos el valor de la vista cuando hay cambios
        this.normalizadorService.getMuestraCobertura()
            .subscribe((value) => {
                this.muestraCobertura = value;
            });

        // Recogemos los datos de la normalización cuando hay cambios
        this.subcribeDatosNormalizacion = this.normalizadorService.getDatosNormalizacion()
            .subscribe((valor) => {
                this.datosNormalizacion = valor;
            });

        // Rellenamos las localidades
        this.subcribeLocalidades = this.normalizadorService.getLocalidades()
            .subscribe(async (local) => {
                this.localidades = local;
                await this.callIfOnlyOneResult();
            });

        // Recuperamos el formulario de normalización
        this.normalizadorService.getFormularioNormalizacion()
            .subscribe((formulario) => {
                this.formularioNormalizacion = formulario;
            });

        // Errores petición http o direcciones vacias
        this.normalizadorService.getErrorPeticionCobertura()
            .subscribe((value) => {
                this.muestraErrorPeticion = value;
            });

        this.normalizadorService.getMsgErrorCobertura()
            .subscribe((value) => {
                this.msgErrorPeticion = value;
            });

        // Recuperamos el id del draft que se esta tramitando por si tenemos que borrarlo
        this.draftService.getOrderIdDraft()
            .subscribe(data => {
                this.orderDraftId = data;
                console.log(data);
            });

        // Retomar tramitación
        this.generalService.getEmptyFormCobertura()
            .subscribe(data => {
                if (data != null) {
                    this.firstFormGroup.get('localidadCobertura').patchValue(data.localidadCobertura);
                    this.firstFormGroup.get('direccionesCobertura').patchValue(data.direccionesCobertura);
                    this.firstFormGroup.get('tipoViaCobertura').patchValue(data.tipoViaCobertura);
                    this.firstFormGroup.get('nombreViaCobertura').patchValue(data.nombreViaCobertura);
                    this.firstFormGroup.get('numeroCobertura').patchValue(data.numeroCobertura);
                    this.firstFormGroup.get('provinciaCobertura').patchValue(data.provinciaCobertura);
                    this.firstFormGroup.get('codigoPostalCobertura').patchValue(data.codigoPostalCobertura);
                    this.firstFormGroup.get('plantaCobertura').patchValue(data.plantaCobertura);
                    this.firstFormGroup.get('bisCobertura').patchValue(data.bisCobertura);
                    this.firstFormGroup.get('bloqueCobertura').patchValue(data.bloqueCobertura);
                    this.firstFormGroup.get('portalCobertura').patchValue(data.portalCobertura);
                    this.firstFormGroup.get('escaleraCobertura').patchValue(data.escaleraCobertura);
                    this.firstFormGroup.get('tipoPuertaCobertura').patchValue(data.tipoPuertaCobertura);
                    this.firstFormGroup.get('puertaCobertura').patchValue(data.puertaCobertura);
                    this.firstFormGroup.get('resultadoConsultaCobertura').patchValue(data.resultadoConsultaCobertura);
                    this.firstFormGroup.get('portabilidadFijo').patchValue(data.portabilidadFijo);
                    this.firstFormGroup.get('tipoAltaFijo').patchValue(data.tipoAltaFijo);
                    this.firstFormGroup.get('serviceProviderFijo').patchValue(data.serviceProviderFijo);
                    this.firstFormGroup.get('numeroApartamento').patchValue(data.numeroApartamento);                    
                    this.firstFormGroup.get('cp_vat').patchValue(data.cp_vat);
                    this.firstFormGroup.get('cp_price').patchValue(data.cp_price);
                    this.firstFormGroup.get('cp_price_without_vat').patchValue(data.cp_price_without_vat);
                    // Si hay cobertura cambiamos las vistas
                    if (data.resultadoConsultaCobertura.access !== '') {
                        // TODO utilizar el valor en vez de la traduccion
                        this.normalizadorService.setResultadoCobertura(this.firstFormGroup);
                        this.normalizadorService.setMuestraNormalizacion(false);
                        this.normalizadorService.setMuestraCobertura(false);
                        let tiposAcceso = [];
                        console.log(data.tiposAccesoRetramita);
                        tiposAcceso.push(data.tiposAccesoRetramita);

                        this.normalizadorService.setRealtechnology(tiposAcceso);
                    }
                }
            });

        this.amenaService.getMigrationData()
            .subscribe((data: any) => {
                this.migrationData = data;
            });

    }

    // GETTERS
    callIfOnlyOneResult() {
        if (this.localidades !== null && this.localidades.length === 1) {
            this.firstFormGroup.get('localidadCobertura').patchValue(this.localidades[0]);
            this.firstFormGroup.get('localidadCobertura').disable();
            this.onChangeLocalidad(this.localidades[0]);
        }
    }

    // SETTERS
    // Filtramos y seteamos el valor de las direcciones sugeridas
    setDireccionesSugeridas(localidad) {
        const dirSugeridas = this.datosNormalizacion
            .filter((el) => {
                if (el.streetName == null) {
                    return null;
                }
                // return el.city ? el.city.toUpperCase() : el.city === localidad ? localidad.toUpperCase() : localidad;
                return el.city && el.city !== '' ? (el.city.toUpperCase() === localidad.toUpperCase()) : null;
            })
            .map((el) => {
                const valorTexto = (el.streetType ? el.streetType.toUpperCase() + ' , ' : '') +
                    (el.streetName ? el.streetName.toUpperCase() + ' , ' : '') +
                    (el.streetNr ? el.streetNr + ' , ' : '') +
                    (el.postCode ? el.postCode : '');
                return {
                    streetType: el.streetType ? el.streetType.toUpperCase() : el.streetType,
                    streetName: el.streetName ? el.streetName.toUpperCase() : el.streetName,
                    streetNr: el.streetNr,
                    postCode: el.postCode,
                    stateOrProvince: el.stateOrProvince,
                    texto: valorTexto
                };
            });

        this.direccionesSugeridas = this.getUnique(dirSugeridas, 'texto');
        if (this.direccionesSugeridas.length === 1) {
            this.firstFormGroup.get('direccionesCobertura').disable();
            this.onChangeDireccionesSugeridas(this.direccionesSugeridas[0]);
        }
    }

    setPlantas(dir) {
        this.plantas = this.datosNormalizacion
            .filter((el) => {
                return (el.city ? el.city.toUpperCase() : el.city) === (this.firstFormGroup.get('localidadCobertura') ? this.firstFormGroup.get('localidadCobertura').value.toUpperCase() : this.firstFormGroup.get('localidadCobertura').value) &&
                    (el.streetType ? el.streetType.toUpperCase() : el.streetType) === (dir.streetType ? dir.streetType.toUpperCase() : dir.streetType) &&
                    (el.streetName ? el.streetName.toUpperCase() : el.streetName) === (dir.streetName ? dir.streetName.toUpperCase() : dir.streetName) &&
                    el.streetNr === dir.streetNr &&
                    el.postCode === dir.postCode;
            })
            .map((el) => el.floorNumber_translation)
            .filter((value, index, self) => self.indexOf(value) === index);

        // Aux para migracion
        const auxPlantas = this.datosNormalizacion
            .filter((el) => {
                return (el.city ? el.city.toUpperCase() : el.city) === (this.firstFormGroup.get('localidadCobertura') ? this.firstFormGroup.get('localidadCobertura').value.toUpperCase() : this.firstFormGroup.get('localidadCobertura').value) &&
                    (el.streetType ? el.streetType.toUpperCase() : el.streetType) === (dir.streetType ? dir.streetType.toUpperCase() : dir.streetType) &&
                    (el.streetName ? el.streetName.toUpperCase() : el.streetName) === (dir.streetName ? dir.streetName.toUpperCase() : dir.streetName) &&
                    el.streetNr === dir.streetNr &&
                    el.postCode === dir.postCode;
            })
            .map((el) => {
                return {
                    label: el.floorNumber_translation,
                    value: el.floorNumber
                }
            })
            .filter((value, index, self) => self.indexOf(value) === index);

        if (
            this.migrationData && this.migrationData.migrationFibraData &&
            this.migrationData.migrationFibraData.installation_address && this.migrationData.migrationFibraData.installation_address.length && 
            this.migrationData.migrationFibraData.installation_address[0].floorNumber && this.migrationData.migrationFibraData.installation_address[0].floorNumber !== ''
        ) {
            const found = auxPlantas.find(x => x.value === this.migrationData.migrationFibraData.installation_address[0].floorNumber);
            if (found) {
                this.firstFormGroup.get('plantaCobertura').patchValue(found.label);
                this.firstFormGroup.get('plantaCobertura').disable();
                this.onChangePlanta();
            }
            
        }
    }

    // Asignamos en este punto las direcciones filtradas por si solo queda una (no hay opciones que mostrar)
    setConsulta() {
        this.consulta = this.datosNormalizacion.filter(
            (el) => {
                return (el.city ? el.city.toUpperCase() : el.city) === (this.firstFormGroup.get('localidadCobertura').value ? this.firstFormGroup.get('localidadCobertura').value.toUpperCase() : this.firstFormGroup.get('localidadCobertura').value) &&
                    (el.streetType ? el.streetType.toUpperCase() : el.streetType) === (this.firstFormGroup.get('tipoViaCobertura').value ? this.firstFormGroup.get('tipoViaCobertura').value.toUpperCase() : this.firstFormGroup.get('tipoViaCobertura').value) &&
                    (el.streetName ? el.streetName.toUpperCase() : el.streetName) === (this.firstFormGroup.get('nombreViaCobertura').value ? this.firstFormGroup.get('nombreViaCobertura').value.toUpperCase() : this.firstFormGroup.get('nombreViaCobertura').value) &&
                    el.streetNr === this.firstFormGroup.get('numeroCobertura').value &&
                    el.postCode === this.firstFormGroup.get('codigoPostalCobertura').value &&
                    el.floorNumber_translation === this.firstFormGroup.get('plantaCobertura').value;
            }
        );
    }

    // Consulta sin campo planta obligatorio
    setConsultaNinguna() {
        this.consulta = this.datosNormalizacion.filter(
            (el) => {
                return (el.city ? el.city.toUpperCase() : el.city) === (this.firstFormGroup.get('localidadCobertura').value ? this.firstFormGroup.get('localidadCobertura').value.toUpperCase() : this.firstFormGroup.get('localidadCobertura').value) &&
                    (el.streetType ? el.streetType.toUpperCase() : el.streetType) === (this.firstFormGroup.get('tipoViaCobertura').value ? this.firstFormGroup.get('tipoViaCobertura').value.toUpperCase() : this.firstFormGroup.get('tipoViaCobertura').value) &&
                    (el.streetName ? el.streetName.toUpperCase() : el.streetName) === (this.firstFormGroup.get('nombreViaCobertura').value ? this.firstFormGroup.get('nombreViaCobertura').value.toUpperCase() : this.firstFormGroup.get('nombreViaCobertura').value) &&
                    el.streetNr === this.firstFormGroup.get('numeroCobertura').value &&
                    el.postCode === this.firstFormGroup.get('codigoPostalCobertura').value;
            }
        );
    }

    // Consultamos si hay opciones para bis duplicado
    setBis(selectedEmpty?) {
        this.bisOption = this.consulta
            // .filter((el) => el.streetNrSuffix_translation)
            .map((el) => el.streetNrSuffix_translation ? el.streetNrSuffix_translation : 'No tiene')
            .filter((value, index, self) => self.indexOf(value) === index);

        if (this.bisOption && this.bisOption.length === 1 && this.bisOption[0] === 'No tiene' && this.firstFormGroup.get('bisCobertura').value !== 'No tiene' && !selectedEmpty) {
            this.bisOption = null;
        } else {
            // Esta no me la está devolviendo el micro
            // Aux para migracion
            const auxBisOption = this.consulta
                // .filter((el) => el.streetNrSuffix_translation)
                .map((el) => {
                    return {
                        label: el.streetNrSuffix_translation ? el.streetNrSuffix_translation : 'No tiene',
                        value: el.streetNrSuffix
                    }
                })
                .filter((value, index, self) => self.indexOf(value) === index);

            if (
                this.migrationData && this.migrationData.migrationFibraData &&
                this.migrationData.migrationFibraData.installation_address && this.migrationData.migrationFibraData.installation_address.length &&
                this.migrationData.migrationFibraData.installation_address[0].streetNrSuffix !== ''
            ) {
                const found = auxBisOption.find(x => x.value === this.migrationData.migrationFibraData.installation_address[0].streetNrSuffix);
                if (found) {
                    this.firstFormGroup.get('bisCobertura').patchValue(found.label);
                    this.firstFormGroup.get('bisCobertura').disable();
                }
            }
        }
        
    }

    // Consultamos si hay opciones para bloque
    setBloque(selectedEmpty?) {
        this.bloqueOption = this.consulta
            // .filter((el) => el.geographicSubAddress[0].subUnitNumber_translation)
            .map((el) => el.geographicSubAddress[0].subUnitNumber_translation ? el.geographicSubAddress[0].subUnitNumber_translation : 'No tiene')
            .filter((value, index, self) => self.indexOf(value) === index);

        if (this.bloqueOption && this.bloqueOption.length === 1 && this.bloqueOption[0] === 'No tiene' && this.firstFormGroup.get('bloqueCobertura').value !== 'No tiene' && !selectedEmpty) {
            this.bloqueOption = null;
        } else {
            // Aux para migracion
            const auxBloqueOption = this.consulta
            // .filter((el) => el.geographicSubAddress[0].subUnitNumber_translation)
            .map((el) => {
                return {
                    label: el.geographicSubAddress[0].subUnitNumber_translation ? el.geographicSubAddress[0].subUnitNumber_translation : 'No tiene',
                    value: el.geographicSubAddress[0].subUnitNumber
                }                
            })
            .filter((value, index, self) => self.indexOf(value) === index);

            if (
                this.migrationData && this.migrationData.migrationFibraData &&
                this.migrationData.migrationFibraData.installation_address && this.migrationData.migrationFibraData.installation_address.length && 
                this.migrationData.migrationFibraData.installation_address[0].subUnitNumber !== ''
            ) {
            const found = auxBloqueOption.find(x => x.value === this.migrationData.migrationFibraData.installation_address[0].subUnitNumber);
                if (found) {
                    this.firstFormGroup.get('bloqueCobertura').patchValue(found.label);
                    this.firstFormGroup.get('bloqueCobertura').disable();
                }            
            }
        }

        this.bloqueLabel = this.consulta
            .filter((el) => el.geographicSubAddress[0].subUnitType_translation)
            .map((el) => el.geographicSubAddress[0].subUnitType_translation)
            .filter((value, index, self) => self.indexOf(value) === index);

        if (this.bloqueLabel && this.bloqueLabel.length > 0) {
            this.bloqueLabel = this.bloqueLabel[0];
        }        

        const auxBloqueLabel = this.consulta
            .filter((el) => el.geographicSubAddress[0].subUnitType_translation)
            .map((el) => {
                return {
                    label: el.geographicSubAddress[0].subUnitType_translation,
                    value: el.geographicSubAddress[0].subUnitType
                }
            })
            .filter((value, index, self) => self.indexOf(value) === index);

        if (
            this.migrationData && this.migrationData.migrationFibraData &&
            this.migrationData.migrationFibraData.installation_address && this.migrationData.migrationFibraData.installation_address.length && 
            this.migrationData.migrationFibraData.installation_address[0].subUnitType && this.migrationData.migrationFibraData.installation_address[0].subUnitType !== ''
        ) {
            const found = auxBloqueLabel.find(x => x.value === this.migrationData.migrationFibraData.installation_address[0].subUnitType);
            if (found) {
                this.firstFormGroup.get('bloqueCobertura').patchValue(found.label);
                this.firstFormGroup.get('bloqueCobertura').disable();              
            }            
        }
    }

    // Consultamos si hay opciones para portal
    setPortal(selectedEmpty?) {
        this.portalOption = this.consulta
            // .filter((el) => el.geographicSubAddress[0].buildingName)
            .map((el) => el.geographicSubAddress[0].buildingName ? el.geographicSubAddress[0].buildingName : 'No tiene')
            .filter((value, index, self) => self.indexOf(value) === index);

        if (this.portalOption && this.portalOption.length === 1 && this.portalOption[0] === 'No tiene' && this.firstFormGroup.get('portalCobertura').value !== 'No tiene' && !selectedEmpty) {
            this.portalOption = null;
        } else {
            // Aux para migracion
            const auxPortalOption = this.consulta
            // .filter((el) => el.geographicSubAddress[0].buildingName)
            .map((el) => {
                return {
                    label: el.geographicSubAddress[0].buildingName ? el.geographicSubAddress[0].buildingName : 'No tiene',
                    value: el.geographicSubAddress[0].buildingName
                }
            })
            .filter((value, index, self) => self.indexOf(value) === index);

            if (
                this.migrationData && this.migrationData.migrationFibraData &&
                this.migrationData.migrationFibraData.installation_address && this.migrationData.migrationFibraData.installation_address.length && 
                this.migrationData.migrationFibraData.installation_address[0].buildingName !== ''
            ) {
                const found = auxPortalOption.find(x => x.value === this.migrationData.migrationFibraData.installation_address[0].buildingName);
                if (found) {
                    this.firstFormGroup.get('portalCobertura').patchValue(found.label);
                    this.firstFormGroup.get('portalCobertura').disable();
                }            
            }
        }        
    }

    // Consultamos si hay opciones para escalera
    setEscalera(selectedEmpty?) {
        this.escaleraOption = this.consulta
            // .filter((el) => el.geographicSubAddress[0].stairCase_translation)
            .map((el) => el.geographicSubAddress[0].stairCase_translation ? el.geographicSubAddress[0].stairCase_translation : 'No tiene')
            .filter((value, index, self) => self.indexOf(value) === index);

        if (this.escaleraOption && this.escaleraOption.length === 1 && this.escaleraOption[0] === 'No tiene' && this.firstFormGroup.get('escaleraCobertura').value !== 'No tiene' && !selectedEmpty) {
            this.escaleraOption = null;
        } else {
            // Aux para migracion
            const auxEscaleraOption = this.consulta
            // .filter((el) => el.geographicSubAddress[0].stairCase_translation)
            .map((el) => {
                return {
                    label: el.geographicSubAddress[0].stairCase_translation ? el.geographicSubAddress[0].stairCase_translation : 'No tiene',
                    value: el.geographicSubAddress[0].stairCase
                }
            })
            .filter((value, index, self) => self.indexOf(value) === index);

            if (
                this.migrationData && this.migrationData.migrationFibraData &&
                this.migrationData.migrationFibraData.installation_address && this.migrationData.migrationFibraData.installation_address.length && 
                this.migrationData.migrationFibraData.installation_address[0].staircaseNumber !== ''
            ) {
                const found = auxEscaleraOption.find(x => x.value === this.migrationData.migrationFibraData.installation_address[0].staircaseNumber);
                if (found) {
                    this.firstFormGroup.get('escaleraCobertura').patchValue(found.label);
                    this.firstFormGroup.get('escaleraCobertura').disable();
                }
            }
        }        
    }

    // Consultamos si hay opciones para tipo puerta
    setTipoPuerta(selectedEmpty?) {
        this.tipoPuertaOption = this.consulta
            // .filter((el) => el.geographicSubAddress[0].doorType_translation)
            .map((el) => el.geographicSubAddress[0].doorType_translation ? el.geographicSubAddress[0].doorType_translation : 'No tiene')
            .filter((value, index, self) => self.indexOf(value) === index);
        
        if (this.tipoPuertaOption && this.tipoPuertaOption.length === 1 && this.tipoPuertaOption[0] === 'No tiene' && this.firstFormGroup.get('tipoPuertaCobertura').value !== 'No tiene' && !selectedEmpty) {
            this.tipoPuertaOption = null;
        } else {
            // Esta no me la está devolviendo el micro
            // Aux para migracion
            const auxTipoPuertaOption = this.consulta
                .filter((el) => el.geographicSubAddress[0].doorType_translation)
                .map((el) => {
                    return {
                        label: el.geographicSubAddress[0].doorType_translation ? el.geographicSubAddress[0].doorType_translation : 'No tiene',
                        value: el.geographicSubAddress[0].doorType
                    }
                })
                .filter((value, index, self) => self.indexOf(value) === index);

            if (
                this.migrationData && this.migrationData.migrationFibraData &&
                this.migrationData.migrationFibraData.installation_address && this.migrationData.migrationFibraData.installation_address.length && 
                this.migrationData.migrationFibraData.installation_address[0].doorType !== ''
            ) {
                const found = auxTipoPuertaOption.find(x => x.value === this.migrationData.migrationFibraData.installation_address[0].doorType);
                if (found) {
                    this.firstFormGroup.get('tipoPuertaCobertura').patchValue(found.label);
                    this.firstFormGroup.get('tipoPuertaCobertura').disable();
                }            
            }
        }        
    }

    // Consultamos si hay opciones para puerta
    setPuerta(selectedEmpty?) {
        this.puertaOption = this.consulta
            // .filter((el) => el.geographicSubAddress[0].door)
            .map((el) => el.geographicSubAddress[0].door ? el.geographicSubAddress[0].door : 'No tiene')
            .filter((value, index, self) => self.indexOf(value) === index);
        
        if (this.puertaOption && this.puertaOption.length === 1 && this.puertaOption[0] === 'No tiene' && this.firstFormGroup.get('puertaCobertura').value !== 'No tiene' && !selectedEmpty) {
            this.puertaOption = null;
        } else {
            // Esta no me la está devolviendo el micro
            // Aux para migracion
            const auxPuertaOption = this.consulta
                // .filter((el) => el.geographicSubAddress[0].door)
                .map((el) => {
                    return {
                        label: el.geographicSubAddress[0].door ? el.geographicSubAddress[0].door : 'No tiene',
                        value: el.geographicSubAddress[0].door
                    }
                })
                .filter((value, index, self) => self.indexOf(value) === index);
            
            if (
                this.migrationData && this.migrationData.migrationFibraData &&
                this.migrationData.migrationFibraData.installation_address && this.migrationData.migrationFibraData.installation_address.length && 
                this.migrationData.migrationFibraData.installation_address[0].door !== ''
            ) {
                const found = auxPuertaOption.find(x => x.value === this.migrationData.migrationFibraData.installation_address[0].door);
                if (found) {
                    this.firstFormGroup.get('puertaCobertura').patchValue(found.label);
                    this.firstFormGroup.get('puertaCobertura').disable();
                }            
            }
        }        
    }

    // METODOS ON
    onChangeLocalidad(localidad) {
        // Limpiamos todas las variables para que afecte a la vista
        this.firstFormGroup.patchValue({
            direccionesCobertura: '',
            tipoViaCobertura: '',
            nombreViaCobertura: '',
            numeroCobertura: '',
            codigoPostalCobertura: '',
            provinciaCobertura: '',
            plantaCobertura: '',
            bisCobertura: null,
            bloqueCobertura: null,
            portalCobertura: null,
            escaleraCobertura: null,
            tipoPuertaCobertura: null,
            puertaCobertura: null
        });
        this.direccionesSugeridas = null;
        this.plantas = null;
        this.bisOption = null;
        this.bloqueOption = null;
        this.portalOption = null;
        this.escaleraOption = null;
        this.tipoPuertaOption = null;
        this.puertaOption = null;
        // Ocultamos botones de consulta
        this.muestraBotonesCobertura = false;
        this.muestraBotonNinguna = false;
        this.firstFormGroup.get('localidadCobertura').patchValue(localidad);
        this.setDireccionesSugeridas(localidad);
    }

    onChangeDireccionesSugeridas(dir) {
        this.firstFormGroup.patchValue({
            plantaCobertura: '',
            bisCobertura: null,
            bloqueCobertura: null,
            portalCobertura: null,
            escaleraCobertura: null,
            tipoPuertaCobertura: null,
            puertaCobertura: null
        });
        this.plantas = null;
        this.bisOption = null;
        this.bloqueOption = null;
        this.portalOption = null;
        this.escaleraOption = null;
        this.tipoPuertaOption = null;
        this.puertaOption = null;
        // Mostramos boton ninguna anteriores
        this.muestraBotonNinguna = true;
        this.muestraBotonesCobertura = false;
        // Asignamos los valores al firstFormGroup para que sea accesible desde todo el formulario
        this.firstFormGroup.get('direccionesCobertura').patchValue(dir.texto ? dir.texto : (dir.streetName ? dir.streetName.toUpperCase() : dir.streetName));
        this.firstFormGroup.get('tipoViaCobertura').patchValue(dir.streetType);
        this.firstFormGroup.get('nombreViaCobertura').patchValue(dir.streetName ? dir.streetName.toUpperCase() : dir.streetName);
        this.firstFormGroup.get('numeroCobertura').patchValue(dir.streetNr);
        this.firstFormGroup.get('codigoPostalCobertura').patchValue(dir.postCode);
        this.firstFormGroup.get('provinciaCobertura').patchValue(dir.stateOrProvince ? dir.stateOrProvince.toUpperCase() : dir.stateOrProvince);

        this.setPlantas(dir);
    }

    onChangePlanta() {
        this.resetControlsForm();
        // Limpiamos todas las variables para que afecte a la vista
        this.firstFormGroup.patchValue({
            bisCobertura: null,
            bloqueCobertura: null,
            portalCobertura: null,
            escaleraCobertura: null,
            tipoPuertaCobertura: null,
            puertaCobertura: null
        });
        this.bisOption = null;
        this.bloqueOption = null;
        this.portalOption = null;
        this.escaleraOption = null;
        this.tipoPuertaOption = null;
        this.puertaOption = null;
        // Mostramos botones de consulta
        this.muestraBotonesCobertura = true;
        // Rellenamos las opciones si hay resultado para ellas
        this.setConsulta();
        this.setBis();
        this.setBloque();
        this.setPortal();
        this.setEscalera();
        this.setTipoPuerta();
        this.setPuerta();

    }

    // Comprobamos si existe consulta para los datos seleccionados, si no existe se añaden las
    // validaciones de las opciones para que salte el error de campo obligatorio
    // compruebaSiExisteConsulta() {
    //     if (this.consulta === null) {
    //         return;
    //     }
    //     const tmp = this.consulta.filter(
    //         (el) => {
    //             return el.geographicSubAddress[0].levelNumber === this.firstFormGroup.value.plantaCobertura &&
    //                 el.streetNrSuffix === this.firstFormGroup.value.bisCobertura &&
    //                 el.geographicSubAddress[0].subUnitType === this.firstFormGroup.value.bloqueCobertura &&
    //                 el.geographicSubAddress[0].buildingName === this.firstFormGroup.value.portalCobertura &&
    //                 el.geographicSubAddress[0].stairCase === this.firstFormGroup.value.escaleraCobertura &&
    //                 el.geographicSubAddress[0].doorType === this.firstFormGroup.value.tipoPuertaCobertura &&
    //                 el.geographicSubAddress[0].door === this.firstFormGroup.value.puertaCobertura;
    //         }
    //     ).map((el) => {
    //         return el;
    //     });
    //     if (tmp !== null && tmp.length > 0) {
    //         // Si existe consulta reseteamos los errores y asignamos la consulta
    //         this.resetControlsForm();
    //         this.consulta = tmp;
    //     } else {
    //         // Si no añadimos las validaciones para que se muestren los errores
    //         this.addAllValidationsCobertura();
    //     }
    // }

    // Retroalimentamos la consulta para que solo nos muestre las opciones correctas para lo seleccionado
    onSelectOpcion(key, value) {
        let selectedEmptyMain = false;
        let selectedEmpty = {
            bis: false,
            bloque: false,
            portal: false,
            escalera: false,
            tipoPuerta: false,
            puerta: false
        };
        if (value === 'No tiene') {
            value = null;
            selectedEmptyMain = true;
        }
        // bis
        if (key === 'streetNrSuffix') {
            this.consulta = this.consulta
                .filter((el) => el[key + '_translation'] === value)
                .map((el) => el);
            
            selectedEmpty.bis = selectedEmptyMain;
        }
        // Bloque
        if (key === 'subUnitNumber') {
            this.consulta = this.consulta
                .filter((el) => el.geographicSubAddress[0][key + '_translation'] === value)
                .map((el) => el);
            
            selectedEmpty.bloque = selectedEmptyMain;
        }
        // Portal
        if (key === 'buildingName') {
            this.consulta = this.consulta
                .filter((el) => el.geographicSubAddress[0][key] === value)
                .map((el) => el);
            
            selectedEmpty.portal = selectedEmptyMain;
        }
        // Escalera
        if (key === 'stairCase') {
            this.consulta = this.consulta
                .filter((el) => el.geographicSubAddress[0][key + '_translation'] === value)
                .map((el) => el);

            selectedEmpty.escalera = selectedEmptyMain;
            this.firstFormGroup.get('escaleraCobertura').patchValue(value ? value.value : value);
        }
        // Tipo puerta
        if (key === 'doorType') {
            this.consulta = this.consulta
                .filter((el) => el.geographicSubAddress[0][key + '_translation'] === value)
                .map((el) => el);
            
            selectedEmpty.tipoPuerta = selectedEmptyMain;
        }
        // Puerta
        if (key === 'door') {
            this.consulta = this.consulta
                .filter((el) => el.geographicSubAddress[0][key] === value)
                .map((el) => el);
            
            selectedEmpty.puerta = selectedEmptyMain;
        }
        this.setBis(selectedEmpty.bis);
        this.setBloque(selectedEmpty.bloque);
        this.setPortal(selectedEmpty.portal);
        this.setEscalera(selectedEmpty.escalera);
        this.setTipoPuerta(selectedEmpty.tipoPuerta);
        this.setPuerta(selectedEmpty.puerta);
        this.addAllValidationsCobertura();
    }

    onConsultarCobertura() {
        let currentZip = this.firstFormGroup.get('codigoPostalCobertura').value;

        if (this.formularioNormalizacion != null && (currentZip === null || currentZip === '')) {
            currentZip = this.formularioNormalizacion.get('codigoPostalNormaliza').value;
            this.firstFormGroup.get('codigoPostalCobertura').patchValue(currentZip);
        }

        this.normalizadorService.setErrorPeticionCobertura(false);
        this.normalizadorService.setMsgErrorCobertura('');
        this.addAllValidationsCobertura();
        // this.compruebaSiExisteConsulta();
        this.validateAllFormFields(this.firstFormGroup);
        if (this.firstFormGroup.status === 'VALID') {
            this.onChangeLoading(true);
            this.normalizadorService.setMuestraNormalizacion(false);
            this.normalizadorService.setResultadoCobertura(this.firstFormGroup);
            let body;
            if (this.consulta.length > 1) {
                const found = this.consulta.find(x => x.geographicSubAddress && x.geographicSubAddress.length && x.geographicSubAddress[0].subUnitNumber_translation === this.firstFormGroup.get('bloqueCobertura').value);
                body = found ? found : this.consulta[0];
            } else {
                body = this.consulta[0];
            }            
            this.normalizadorService.consultaCobertura(body, this.flagUAT)
                .subscribe((data: any) => {
                    if (data.msg) {
                        data = data.msg;
                    }
                    if (data.cimaArvatoCode && data.cimaArvatoCode !== '') {
                        this.firstFormGroup.get('resultadoConsultaCobertura').patchValue(data);
                        this.firstFormGroup.get('numeroApartamento').patchValue(body && body.apartmentNumber ? body.apartmentNumber : '');
                        this.normalizadorService.setRealtechnology(this.migrationData.migrationFibraData.technology);
                        this.clearFormGroup();
                        this.normalizadorService.setResultadoCobertura(this.getValueForCobertura(this.firstFormGroup, body));
                        this.normalizadorService.setMuestraCobertura(false);
                        this.onChangeLoading(false);
                        this.firstFormGroup.enable();
                    } else {
                        this.normalizadorService.setErrorPeticionCobertura(true);
                        this.normalizadorService.setMsgErrorCobertura(this.htmlErrorCobertura);
                        // Si se cambia la posicion al solicitar cliente se debe mover
                        // this.normalizadorService.setClientIsCover(false);
                        this.onChangeLoading(false);
                        this.firstFormGroup.enable();
                    }
                }, (error) => {
                    let msgError;
                    if (error.error.error.msg) {
                        msgError = error.error.error.msg;
                    } else {
                        msgError = 'Error interno. Por favor intentelo más tarde.';
                    }
                    this.normalizadorService.setErrorPeticionCobertura(true);
                    this.normalizadorService.setMsgErrorCobertura(msgError);
                    this.onChangeLoading(false);
                    this.firstFormGroup.enable();
                });
        } else {
            this.onChangeLoading(false);
        }

    }

    onConsultarNingunaAnteriores() {
        this.normalizadorService.setErrorPeticionCobertura(false);
        this.normalizadorService.setMsgErrorCobertura('');
        this.resetControlsForm();
        this.clearValidations('plantaCobertura');
        this.clearValidations('bisCobertura');
        this.clearValidations('bloqueCobertura');
        this.clearValidations('portalCobertura');
        this.clearValidations('escaleraCobertura');
        this.clearValidations('tipoPuertaCobertura');
        this.clearValidations('puertaCobertura');
        if (this.firstFormGroup.status === 'VALID') {
            this.onChangeLoading(true);
            this.firstFormGroup.disable();
            this.setConsultaNinguna();
            this.firstFormGroup.patchValue({
                bisCobertura: null,
                bloqueCobertura: null,
                portalCobertura: null,
                escaleraCobertura: null,
                tipoPuertaCobertura: null,
                puertaCobertura: null,
                plantaCobertura: null
            });
            const body = this.limpiarConsultaNingunaAnteriores(this.consulta);
            this.normalizadorService.consultaNingunaAnteriores(body)
                .subscribe((data: any) => {
                    if (data.cimaArvatoCode && data.cimaArvatoCode !== '') {
                        this.firstFormGroup.get('resultadoConsultaCobertura').patchValue(data);
                        // this.normalizadorService.setTiposDeAcceso(data.technology);
                        this.normalizadorService.setRealtechnology(this.migrationData.migrationFibraData.technology);
                        this.normalizadorService.setResultadoCobertura(this.firstFormGroup);
                        this.normalizadorService.setMuestraNormalizacion(false);
                        this.normalizadorService.setMuestraCobertura(false);
                        this.onChangeLoading(false);
                        this.firstFormGroup.enable();
                    } else {
                        this.normalizadorService.setErrorPeticionCobertura(true);
                        this.normalizadorService.setMsgErrorCobertura(this.htmlErrorCobertura);
                        // Si se cambia la posicion al solicitar cliente se debe mover
                        // this.normalizadorService.setClientIsCover(false);
                        this.onChangeLoading(false);
                        this.firstFormGroup.enable();
                    }
                }, (error) => {
                    let msgError;
                    if (error.error.error.msg) {
                        msgError = error.error.error.msg;
                    } else {
                        msgError = 'Error interno. Por favor intentelo más tarde.';
                    }
                    this.normalizadorService.setErrorPeticionCobertura(true);
                    this.normalizadorService.setMsgErrorCobertura(msgError);
                    this.onChangeLoading(false);
                    this.firstFormGroup.enable();
                });
        } else {
            this.onChangeLoading(false);
            this.firstFormGroup.enable();
        }
    }

    limpiarConsultaNingunaAnteriores(consultaInicial) {
        if (consultaInicial && consultaInicial.length) {
            let consulta = '';
            consultaInicial[0].geographicSubAddress[0].levelNumber = null;
            consultaInicial[0].streetNrSuffix = null;
            consultaInicial[0].geographicSubAddress[0].subUnitType = null;
            consultaInicial[0].geographicSubAddress[0].subUnitNumber = null;
            consultaInicial[0].geographicSubAddress[0].buildingName = null;
            consultaInicial[0].geographicSubAddress[0].stairCase = null;
            consultaInicial[0].geographicSubAddress[0].doorType = null;
            consultaInicial[0].apartmentNumber = null;
            consultaInicial[0].geographicSubAddress[0].door = null;
            consultaInicial[0].staircaseNumber = null;
            consultaInicial[0].streetNrLast = null;
            consultaInicial[0].streetNrLastSuffix = null;
            consultaInicial[0].streetNrSuffix = null;
            // Si existe código gescal lo limpiamos
            for (let i = 0; i < consultaInicial[0].ospAddressExternalId.length; i++) {
                if (consultaInicial[0].ospAddressExternalId[i].refId !== null) {
                    if (consultaInicial[0].ospAddressExternalId[i].refId === 'gescal') {
                        consultaInicial[0].ospAddressExternalId[i].externalId = null;
                    }
                }
            }
            consulta = consultaInicial[0];

            return consulta;
        }
    }

    // VALIDACIONES

    // Añade validación al elemento enviado, solo si hay resultados para ese elemento
    addRequiredControl(nombreControl, elemento) {
        if (elemento) {
            const identificador = this.firstFormGroup.get(nombreControl);
            if (elemento.length) {
                identificador.setValidators([Validators.required]);
            } else {
                this.clearValidations(nombreControl);
            }
        } else {
            this.clearValidations(nombreControl);
        }
    }

    // Añade validaciones para todo el formulario de cobertura
    addAllValidationsCobertura() {
        this.addRequiredControl('bisCobertura', this.bisOption);
        this.addRequiredControl('bloqueCobertura', this.bloqueOption);
        this.addRequiredControl('portalCobertura', this.portalOption);
        this.addRequiredControl('escaleraCobertura', this.escaleraOption);
        this.addRequiredControl('tipoPuertaCobertura', this.tipoPuertaOption);
        this.addRequiredControl('puertaCobertura', this.puertaOption);
    }

    // Reset errores de validación para la consulta ninguna de las anteriores
    resetControlsForm() {
        this.firstFormGroup.get('bisCobertura').clearValidators();
        this.firstFormGroup.get('bloqueCobertura').clearValidators();
        this.firstFormGroup.get('portalCobertura').clearValidators();
        this.firstFormGroup.get('escaleraCobertura').clearValidators();
        this.firstFormGroup.get('tipoPuertaCobertura').clearValidators();
        this.firstFormGroup.get('puertaCobertura').clearValidators();
    }

    // Comprueba si existen errores de validacion y hace saltar estos errores
    validateAllFormFields(formGroup: FormGroup | FormArray): boolean {
        const keysArray = formGroup instanceof FormGroup ? Object.values(formGroup.controls) : formGroup.controls;
        keysArray.forEach(control => {
            if (control instanceof FormControl) {
                control.markAsTouched({onlySelf: false});
                control.updateValueAndValidity();
            } else if (control instanceof FormGroup || control instanceof FormArray) {
                this.validateAllFormFields(control);
            }
        });
        return formGroup.invalid;
    }

    // Funcion para limpiar las validaciones de un campo del formulario
    clearValidations(nameForm: string) {
        this.firstFormGroup.get(nameForm).clearValidators();
        this.firstFormGroup.get(nameForm).setValidators([]);
        this.firstFormGroup.get(nameForm).updateValueAndValidity();
    }

    // Función para manejar los mensajes de error
    public errorHandling = (control: string, error: string) => {
        if (this.firstFormGroup.get(control).invalid && (this.firstFormGroup.get(control).dirty || this.firstFormGroup.get(control).touched)) {
            return this.firstFormGroup.controls[control].hasError(error);
        }
    }

    getValueForCobertura(formGroup, resultCobertura?) {
        if (resultCobertura) {
            formGroup.get('plantaCobertura').patchValue(resultCobertura.floorNumber);
            formGroup.get('bisCobertura').patchValue(resultCobertura.streetNrSuffix);
            if (resultCobertura.geographicSubAddress && resultCobertura.geographicSubAddress.length) {
                formGroup.get('bloqueCobertura').patchValue(resultCobertura.geographicSubAddress[0].subUnitNumber);
                formGroup.get('escaleraCobertura').patchValue(resultCobertura.geographicSubAddress[0].stairCase);
                formGroup.get('tipoPuertaCobertura').patchValue(resultCobertura.geographicSubAddress[0].doorType);
            }
        }
        return formGroup;
    }

    // UTILS

    // Devuelve valores unicos para un identificador dado
    getUnique(array, identificador) {
        const unique = array
            .map(e => e[identificador])
            .map((e, i, final) => final.indexOf(e) === i && i)
            .filter(e => array[e]).map(e => array[e]);

        return unique;
    }

    onChangeLoading(state) {
        if (state === true) {
            this.isLoading = true;
            this.textDefault = 'Comprobando ...';
        } else {
            this.isLoading = false;
            this.textDefault = 'Confirmar dirección';
        }
    }

    clearFormGroup() {
        for (const field in this.firstFormGroup.controls) {
            if (this.firstFormGroup.get(field).value === 'No tiene') {
                this.firstFormGroup.get(field).patchValue(null);
            }
        }
    }
}

